import { render, staticRenderFns } from "./productosComponent.vue?vue&type=template&id=250a5b4c&scoped=true&"
import script from "./productosComponent.vue?vue&type=script&lang=js&"
export * from "./productosComponent.vue?vue&type=script&lang=js&"
import style0 from "./productosComponent.vue?vue&type=style&index=0&id=250a5b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a5b4c",
  null
  
)

export default component.exports